export const CREW_DOMAIN_NAME = {
  ALL: 'all',
  MARPPLE: 'marpple',
  NAVER_WEBTOON: 'webtoonfriends',
  NBOX: 'nbox',
};

export const CREW_SELLER_SHARE_TYPE = {
  CUSTOMER_PRICE: 'customer_price',
  TOTAL_PROFIT: 'total_profit',
};
